import Hero from "../component/hero/Hero";

import Currency from "../component/currency/Currency";
import About from "../component/about/About";
import Package from "../component/package/Package";
import Subscribe from "../component/subscribe/Subscribe";
import Guide from "../component/guide/Guide";

import Influencers from "../component/influencers/Influencers";
import Airdrop from "../component/influencers/Airdrop";

export default function Home(){
    return(
        <>
        <Hero />
        {/* <Currency /> */}
        <About />
        <Package />
        <Guide />
        <Influencers />
        <Airdrop />
        <Subscribe />
        </>
    );
};